var map = {
  "./pl.messages.tsx": [
    "65112",
    [
      4827
    ]
  ],
  "./cs.messages.tsx": [
    "56350",
    [
      309
    ]
  ],
  "./en.messages.tsx": [
    "71111",
    [
      8974
    ]
  ],
  "./hu.messages.tsx": [
    "37059",
    [
      2282
    ]
  ],
  "./de.messages.tsx": [
    "29103",
    [
      1382
    ]
  ],
  "./it.messages.tsx": [
    "85297",
    [
      4796
    ]
  ],
  "./sk.messages.tsx": [
    "48854",
    [
      3757
    ]
  ]
};
function __rspack_async_context(req) {
  if(!__webpack_require__.o(map, req)) {
    return Promise.resolve().then(() => {
var e = new Error("Cannot find module '" + req + "'");
e.code = 'MODULE_NOT_FOUND';
throw e;
});
  }

  var ids = map[req], id = ids[0];
  return __webpack_require__.e(ids[1][0]).then(() => (__webpack_require__(id)));
}

__rspack_async_context.keys = () => (Object.keys(map));
__rspack_async_context.id = 89728;
module.exports = __rspack_async_context;
